import React from 'react'

import POHistoryOutlet from '@/components/views/ci/PO/POHistoryOutlet'

const PO_POHistoryOutlet = () => {
    return <POHistoryOutlet />
}

export default PO_POHistoryOutlet
